import { objectsToCsv, toCsv } from './csv';

/**
 * Hand the browser a CSV file.
 *
 * Its own module rather than part of `csv.ts` because `csv.ts` is a MIRRORED
 * file — it has a server twin, and `mirroredUtilParity.test.js` requires the
 * client twin to export nothing the server does not. A function that reaches
 * for `document` and `URL.createObjectURL` has no server counterpart and never
 * will, so it lives here and the escaping rules stay mirrored.
 *
 * Here at all because the five copies of `downloadCsv` this replaces sat in the
 * same five pages as the five copies of `csvEscape` (TECH_DEBT #38) — same
 * files, same shape, retired together. Four built their rows from objects and
 * one from arrays, which is why both entry points exist.
 */

/** The UTF-8 BOM. Without it Excel on Windows reads the file as the system
 * codepage and a supplier name with an accent in it arrives mangled. */
const BOM = '﻿';

function save(filename: string, csv: string): void {
  if (!csv) return;
  const blob = new Blob([BOM, csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/**
 * Download rows of objects as a CSV, with a header row.
 * Column order comes from `headers`, or from the first row's own keys.
 * Nothing is downloaded when there are no rows.
 */
export function downloadObjectsCsv(
  filename: string,
  rows: Array<Record<string, unknown>>,
  headers?: string[]
): void {
  save(filename, objectsToCsv(rows, headers));
}

/**
 * Download rows of cells as a CSV. The caller decides whether the first row is
 * a header.
 */
export function downloadRowsCsv(filename: string, rows: Array<Array<unknown>>): void {
  save(filename, toCsv(rows));
}
